export default {
  getLoading(state) {
    return state.loading;
  },
  getLoadingText(state) {
    return state.loadingText;
  },
  getModalOpenName(state) {
    return state.modalOpenName;
  },
  getRequestInProgress(state) {
    return state.requestInProgress;
  },
  getServicesAdded(state) {
    return state.servicesAdded;
  },
  getIsModalOpen(state) {
    return state.isModalOpen;
  },
  isShowSideBar(state) {
    return state.showSideBar;
  },
  getDisplayLoadingProgress(state) {
    return state.displayLoadingProgress;
  },
  getLoadingProgressValue(state) {
    return state.loadingProgressValue;
  },
  getLoadingProgressText(state) {
    return state.loadingProgressText;
  },
  getServiceActionsModal(state) {
    return state.serviceActionsModal;
  },
  getIsViewContractSalesManualModalOpen(state) {
    return state.isViewContractSalesManualModalOpen;
  },
  getHistoryView(state) {
    return state.historyView;
  },
};
